import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { IAdministrationState } from './state';
import { GETDOKUMENTE, TOTAL_NUMBER_OF_RECORDS } from '@/areas/kunde/archiv/store/getters';

export const GETTAKETEILNEHMERDATA = 'getTakeTeilnehmerData';
export const GET_TEILNEHMER_DATA = 'getTeilnehmerList';
export const GET_TEILNEHMER_LOADING = 'getTeilnehmerLoading';
export const GET_ARTIKEL_LOADING = 'getArtikelLoading';
export const GET_ARTIKEL_DATA = 'getArtikelData';
export const GET_TEILNEHMER_TOTAL_NUMBER_OF_RECORDS = 'getTeilnehmerTotalNumberOfRecords';
export const GET_ARTIKEL_TOTAL_NUMBER_OF_RECORDS = 'getArtikelTotalNumberOfRecords';
export const GET_BENUTZER_DATA = 'GetBenutzerData';
export const GET_BENUTZER_LOADING = 'GetBenutzerLoading';
export const GET_BENUTZER_TOTAL_NUMBER_OF_RECORDS = 'getBenutzerTotalNumberOfRecords';
export const GETVETDATALOG = 'getVetdataLog';
export const GET_LIEFERANT_DETAILS = 'getLieferantDetails';
export const GET_LIEFERANTEN_DOKUMENTE = 'getLieferantenDokumente';
export const LIEFERANTEN_DOKUMENTE_TOTAL_NUMBER_OF_RECORDS = 'getLieferantenDokumenteTotalNumberOfRecords';
export const DOKUMENTE_LOADING = 'getDokumenteLoading';
export const GET_LIEFERANTEN = 'getLieferanten';
export const FEHLERHAFTE_RECHNUNGEN_ADMIN = 'fehlerhafteRechnungenAdmin';
export const FEHLERHAFTE_RECHNUNGEN_LOADING_ADMIN = 'fehlerhafteRechnungenLoadingAdmin';
export const FEHLERHAFTE_RECHNUNGEN_TOTAL_ADMIN = 'fehlerhafteRechnungenTotalAdmin';
export const GETBENUTZERDETAILS = 'getBenutzerDetails';

export const getters: GetterTree<IAdministrationState, IRootState> = {
    [GETTAKETEILNEHMERDATA]: (state) => state.teilnehmer,
    [GET_TEILNEHMER_DATA]: (state) => state.teilnehmerList,
    [GET_TEILNEHMER_LOADING]: (state) => state.teilnehmerLoading,
    [GET_TEILNEHMER_TOTAL_NUMBER_OF_RECORDS]: (state) => state.teilnehmerTotalNumberOfRecords,
    [GET_ARTIKEL_LOADING]: (state) => state.artikelLoading,
    [GET_ARTIKEL_DATA]: (state) => state.artikelList,
    [GET_ARTIKEL_TOTAL_NUMBER_OF_RECORDS]: (state) => state.artikelTotalNumberOfRecords,
    [GETVETDATALOG]: (state) => state.vetdataLog,
    [GET_BENUTZER_DATA]: (state) => state.benutzerInfoSearchResultApiDtoList,
    [GET_BENUTZER_LOADING]: (state) => state.benutzerLoading,
    [GET_BENUTZER_TOTAL_NUMBER_OF_RECORDS]: (state) => state.benutzerTotalNumberOfRecords,
    [GET_LIEFERANT_DETAILS]: (state) => state.lieferantDetails,
    [GET_LIEFERANTEN_DOKUMENTE]: (state) => state.lieferantenDokumentList,
    [LIEFERANTEN_DOKUMENTE_TOTAL_NUMBER_OF_RECORDS]: (state) => state.lieferantenDokumenteTotalNumberOfRecords,
    [DOKUMENTE_LOADING]: (state) => state.dokumenteLoading,
    [GETBENUTZERDETAILS]: (state) => state.benutzerDetails,
    [GET_LIEFERANTEN]: (state) => state.lieferantenListe,
    [FEHLERHAFTE_RECHNUNGEN_ADMIN]: (state) => state.fehlerhafteRechnungenList,
    [FEHLERHAFTE_RECHNUNGEN_LOADING_ADMIN]: (state) => state.fehlerhafteRechnungenLoading,
    [FEHLERHAFTE_RECHNUNGEN_TOTAL_ADMIN]: (state) => state.fehlerhafteRechnungenTotalNumberOfRecords
};
